const Calendar = () => {
  return (
    <div className="flex justify-center items-center h-full w-full">
      Soon to be a calendar!
    </div>
  );
};
export default Calendar;
